if (!customElements.get('home-faq-accordion')) {
  class HomeFaqAccordion extends HTMLElement {
    connectedCallback() {
      this.items = this.querySelectorAll('.section-home-faq__item');
      this.questions = this.querySelectorAll('.section-home-faq__q');
      this.tabs = this.querySelectorAll('.section-home-faq__cat');

      this.questions.forEach((btn) => {
        btn.addEventListener('click', this.handleToggle.bind(this));
      });

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick.bind(this));
      });
    }

    handleToggle(event) {
      const button = event.currentTarget;
      const item = button.closest('.section-home-faq__item');
      const isOpen = item.classList.contains('section-home-faq__item--open');

      this.items.forEach((el) => {
        el.classList.remove('section-home-faq__item--open');
        el.querySelector('.section-home-faq__q').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('section-home-faq__item--open');
        button.setAttribute('aria-expanded', 'true');
      }
    }

    handleTabClick(event) {
      const selectedCategory = event.currentTarget.getAttribute('data-category');

      this.tabs.forEach((tab) => {
        const isActive = tab === event.currentTarget;
        tab.classList.toggle('section-home-faq__cat--active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
      });

      this.items.forEach((item) => {
        if (selectedCategory === 'all') {
          item.removeAttribute('hidden');
        } else {
          const itemCategory = item.getAttribute('data-category');
          if (itemCategory === selectedCategory) {
            item.removeAttribute('hidden');
          } else {
            item.setAttribute('hidden', '');
            item.classList.remove('section-home-faq__item--open');
            item.querySelector('.section-home-faq__q').setAttribute('aria-expanded', 'false');
          }
        }
      });
    }
  }

  customElements.define('home-faq-accordion', HomeFaqAccordion);
}
